import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BendingMachineShellComponent } from './containers/bending-machine-shell/bending-machine-shell.component';
import { BendingMachineListComponent } from './components/bending-machine-list/bending-machine-list.component';

@NgModule({
  declarations: [
    BendingMachineShellComponent,
    BendingMachineListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class BendingMachineModule {}
